import type { ReactNode } from "react";

import { cn } from "./lib/cn";

export interface PageHeaderProps {
  /** Sayfanın adı — ekranın tek `<h1>`'i. */
  title: string;
  /** Başlığın altındaki gri açıklama: bu ekran ne işe yarar. */
  description?: string;
  /**
   * Başlığın ÜSTÜNDE duran kırıntı yolu ya da rozet şeridi. Başlığın içine gömmek yerine
   * ayrı yuva: kırıntı yolu bir gezinme (`<nav>`), başlık ise bir metin.
   */
  breadcrumb?: ReactNode;
  /** Başlığın SAĞINDAKİ birincil/ikincil aksiyonlar. */
  actions?: ReactNode;
  /**
   * Başlığın hemen ALTINDAKİ şerit: kayıt numarası, durum rozeti gibi kimlik bilgisi.
   * Aksiyonlardan ayrı, çünkü tıklanmıyor — okunuyor.
   */
  meta?: ReactNode;
  className?: string;
}

/**
 * Sayfa başlığı deseni — onaylı görsel dilin her ekranında aynı.
 *
 * ### Neden bileşen
 *
 * Yirmi dokuz hedef tasarımın hepsinde aynı üç parça var: büyük lacivert başlık, altında
 * gri bir cümle, sağda aksiyonlar. Bu blok sayfalarda tek tek yazıldığında ölçüsü her
 * sayfada biraz kayıyordu (`text-xl` / `text-2xl`, `gap-1` / `gap-2`) ve ekranlar aynı
 * ürünün parçası gibi durmuyordu.
 *
 * ### Bileşen domain BİLMEZ
 *
 * Hangi sayfanın hangi başlığı taşıdığı çağıranın bilgisi; burada yalnız "bir sayfa
 * başlığı nasıl görünür" sorusunun yanıtı var (`packages/ui/CLAUDE.md`).
 */
export function PageHeader({
  title,
  description,
  breadcrumb,
  actions,
  meta,
  className,
}: PageHeaderProps) {
  return (
    <header className={cn("flex flex-col gap-3", className)}>
      {breadcrumb}
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div className="min-w-0 flex-1">
          {/** §2: h1 sabit 30/36/700/fg-strong — global `h1` kuralından (index.css) gelir. */}
          <h1>{title}</h1>
          {description ? <p className="mt-1 text-sm text-fg-muted">{description}</p> : null}
        </div>
        {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
      </div>
      {meta ? <div className="flex flex-wrap items-center gap-2.5">{meta}</div> : null}
    </header>
  );
}
